import InvitationView from './InvitationView'
export default InvitationView
